import { render, staticRenderFns } from "./AttendanceWorkStatsPanel.vue?vue&type=template&id=5e8833c4&scoped=true&"
import script from "./AttendanceWorkStatsPanel.vue?vue&type=script&lang=js&"
export * from "./AttendanceWorkStatsPanel.vue?vue&type=script&lang=js&"
import style0 from "./AttendanceWorkStatsPanel.vue?vue&type=style&index=0&id=5e8833c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8833c4",
  null
  
)

export default component.exports